import { createMachine } from 'xstate';
import { Events, PauseSubscriptionContext } from './types';

const initialContext = {
  error: null,
  status: null,
} as PauseSubscriptionContext;

export const pauseSubscription = createMachine<
  PauseSubscriptionContext,
  Events
>({
  id: 'pauseSubscription',
  initial: 'idle',
  predictableActionArguments: true,
  context: initialContext,
  states: {
    idle: {
      on: {
        PAUSE_SUBSCRIPTION: {
          target: 'pauseSubscription',
        },
      },
    },
    pauseSubscription: {
      invoke: {
        src: 'pauseSubscription',
        onDone: {
          target: 'success',
          actions: 'updateSubscription',
        },
        onError: {
          target: 'error',
          actions: 'setError',
        },
      },
    },
    success: {
      type: 'final',
    },
    error: {
      type: 'final',
    },
  },
});
